import { createContext } from 'react';
import { IGateWay } from '../interfaces/finance';

type ContextType = {
	taxPercent: number;
	fetchedGateWays: IGateWay[] | undefined;
};

export const FinanceContext = createContext<ContextType>({
	taxPercent: 0,
	fetchedGateWays: [],
});
